import swal2 from 'sweetalert2';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js';
import React, { Component } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import Loading from '../ui/Loading.js';
import Config from '../../commons/config/Config.js';
import { FormattedMessage, injectIntl } from 'react-intl';
import { StyledTooltip } from '../../commons/utils/TableStyles';
import Timezone from '../../commons/timezone/Timezone.js';
import Security from '../../commons/security/Security';

$.DataTable = DataTable;

class MovilesRutasImportFilesGrid extends Component {
    // Export the entire grid to Excel
    exportarGrillaExcel = () => {
        this.setState({ loading: true });
        const url = Config.get('apiUrlBase') + '/moviles-rutas/import-files/export-excel';
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization-Token': localStorage.getItem('token')
            }
        })
            .then(response => {
                if (response.status === 200) {
                    return response.blob();
                } else {
                    throw new Error('Error al exportar');
                }
            })
            .then(blob => {
                const fileName = 'moviles_rutas_import_files.xlsx';
                const fileUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = fileUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(fileUrl);
                this.setState({ loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
                swal2.fire('Error', 'No se pudo exportar el archivo.', 'error');
            });
    }
    state = {
        loading: false,
        erroresDetalle: [],
        showErroresModal: false,
        modalFileName: '',
    };
    // Open the modal with the error details
    verDetalleErrores(row) {
        this.setState({ loading: true, modalFileName: row.file_name });
        this.ajaxHandler.fetch(`/disponibilidad/moviles-rutas/import-result/${row.id}`, {
            method: 'GET'
        }).then(response => {
            if (response.status === 200) {
                return response.json();
            }
        }).then(data => {
            this.setState({
                erroresDetalle: Array.isArray(data) ? data : [],
                showErroresModal: true,
                loading: false
            });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    closeErroresModal = () => {
        this.setState({ showErroresModal: false, erroresDetalle: [] });
    }
    componentWillUnmount() {
        if (this.ajaxHandler) {
            this.ajaxHandler.unsubscribe(this);
        }
    }
    // Download the imported file
    exportarDetalle(row) {
        const id = row.id;
        const fileType = row.file_name && row.file_name.endsWith('.csv') ? 'csv' : 'xlsx';
        const fileName = `rutas-importadas-${id}.${fileType}`;
        this.ajaxHandler.fetch(`/disponibilidad/moviles-rutas/archivo-importado/${id}`, {
            method: 'GET'
        }).then(response => {
            if (response.status === 200) {
                return response.blob();
            }
        }).then(fileBlob => {
            if (fileBlob) {
                let fileUrl = URL.createObjectURL(fileBlob);
                $("<a />", {
                    href: fileUrl,
                    download: fileName
                }).appendTo("body").get(0).click();
            }
        });
    }
    constructor(props) {
        super(props);
        this.dataService = '/moviles-rutas/import-files';
        this.state = {
            loading: false,
        };
    }

    componentDidMount() {
        if (!Security.hasPermission("MOVILES_RUTAS_IMPORT_AUDIT_LISTAR")) {
            window.location.href = "/error";
            return;
        }
        this.ajaxHandler = new AjaxHandler(this);
        this.ajaxHandler.subscribe(this);
        this.initGrid();
    }

    initGrid() {
        const component = this;

        this.table = $(this.refs.grid).DataTable({
            dom: 'rt<"row mt-2"<"col-4" l><"col-4 text-center" i><"col-4" p>>',
            processing: true,
            serverSide: false,
            order: [[0, "desc"]],
            ajax: {
                type: 'GET',
                url: Config.get('apiUrlBase') + this.dataService,
                headers: {
                    'Authorization-Token': localStorage.getItem("token")
                },
                dataSrc: response => response,
                cache: false
            },
            columns: [
                {
                    title: 'Fecha de Importación',
                    data: 'imported_at',
                    className: 'all',
                    filterType: 'input',
                    render: data => Timezone.getDateForClient(data, null, 'YYYY-MM-DD HH:mm:ss')
                },
                {
                    title: '',
                    name: 'estado',
                    data: null,
                    width: 3,
                    orderable: false,
                    className: 'p-0 all',
                    render: () => '',
                    createdCell: (td, cellData, rowData) => {
                        $(td).attr('title', rowData.errores === 0 ? 'Sin Fallas' : 'Con Fallas');
                        $(td).tooltip();
                        $(td).addClass(rowData.errores === 0 ? 'status-green' : 'status-red');
                    },
                    filterType: 'none'
                },
                { title: 'Usuario', data: 'user_name', className: 'all', filterType: 'input' },
                { title: 'Archivo', data: 'file_name', className: 'all', filterType: 'input' },
                { title: 'Errores', data: 'errores', className: 'all', filterType: 'none' },
                {
                    orderable: false,
                    name: 'actions',
                    className: "all text-center",
                    width: '120px',
                    render: (data, type, full) => {
                        let viewText = component.props.intl.formatMessage({ id: 'movilesRutasImportFilesGrid.column.view', defaultMessage: 'Ver' });
                        let downloadText = component.props.intl.formatMessage({ id: 'movilesRutasImportFilesGrid.column.download', defaultMessage: 'Descargar' });
                        return `
                            <button ${full.errores === 0 ? 'disabled' : ''} class="action detail btn btn-sm btn-icon btn-dt-grid ${full.errores !== 0 ? 'text-success' : ''}" title="${viewText}">
                                <i class="fa fa-search fa-xs"></i>
                            </button>
                            <button class="action download btn btn-sm btn-icon btn-dt-grid text-success" title="${downloadText}">
                                <i class="fa fa-download fa-xs"></i>
                            </button>`;
                    },
                    filterType: 'none'
                }
            ],
            initComplete: function (settings) {
                const api = this.api();
                api.columns().every(function () {
                    const column = this;
                    const colDef = settings.aoColumns[column.index()];

                    if (colDef.filterType === 'input') {
                        $('<input type="text" class="btn-dt-filter" placeholder="Buscar..." />')
                            .appendTo($(column.footer()).empty())
                            .on('keyup change', function () {
                                if (column.search() !== this.value) {
                                    column.search(this.value).draw();
                                }
                            });
                    }

                    if (colDef.filterType === 'select') {
                        const select = $('<select class="btn-dt-filter"><option value="">Buscar...</option></select>')
                            .appendTo($(column.footer()).empty())
                            .on('change', function () {
                                const val = $.fn.dataTable.util.escapeRegex($(this).val());
                                column.search(val ? val : '', true, false).draw();
                            });

                        column.data().unique().sort().each(function (d) {
                            select.append('<option value="' + d + '">' + d + '</option>');
                        });
                    }
                });
                $('tfoot tr').appendTo('thead');
            }
        });
        $(this.refs.grid).on('click', '.action.download', function () {
            const row = component.table.row($(this).parents('tr')).data();
            component.exportarDetalle(row);
        });
        $(this.refs.grid).on('click', '.action.detail', function () {
            const row = component.table.row($(this).parents('tr')).data();
            if (row && row.errores !== 0) {
                component.verDetalleErrores(row);
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className="content-wrapper">
                    <div className="content-header row">
                        <div className="content-header-left col-md-6 col-12 mb-2">
                            <h3 className="content-header-title">
                                <FormattedMessage
                                    id="movilesRutasImportFilesGrid.header_title.imported_files"
                                    defaultMessage="Importaciones de Rutas de Móviles"
                                />
                            </h3>
                        </div>
                    </div>
                    {this.state.loading && <Loading />}
                    <div className="row mt-2">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-content collpase show">
                                    <div className="card-body card-dashboard">
                                        <div className="d-flex justify-content-end mb-2">
                                            <div className="dt-buttons btn-group">
                                                {Security.hasPermission("MOVILES_RUTAS_IMPORT_AUDIT_EXPORTAR") &&
                                                    <div className="dropdown d-inline-block">
                                                        <StyledTooltip
                                                            title={this.props.intl.formatMessage({
                                                                id: 'movilesGrid.tools_export.title_exportar_a_excel',
                                                                defaultMessage: 'Exportar a Excel',
                                                            })}
                                                            arrow
                                                            placement="top"
                                                        >
                                                            <button className="btn btn-secondary buttons-collection dropdown-toggle" type="button" id="dropdownMenuExport" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <span>
                                                                    <i className="ft-upload"></i>
                                                                </span>
                                                            </button>
                                                        </StyledTooltip>
                                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuExport">
                                                            <button onClick={this.exportarGrillaExcel} className="btn-light dropdown-item" type="button" style={{ cursor: 'pointer' }}>
                                                                <FormattedMessage id="movilesGrid.tools_export.title_exportar_a_excel" defaultMessage="Exportar a Excel" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table id="dataTable" className="table nowrap table-hover" ref="grid" width="100%">
                                                <tfoot>
                                                    <tr style={{ backgroundColor: '#fff' }}>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Errors Modal */}
                    {this.state.showErroresModal && (
                        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header bg-fleet">
                                        <h4 className="modal-title text-white"><FormattedMessage id="movilesRutasImportFilesGrid.errorDetails" defaultMessage="Detalle de Errores" /> - {this.state.modalFileName}</h4>
                                        <button type="button" className="close" onClick={this.closeErroresModal}><span aria-hidden="true">&times;</span></button>
                                    </div>
                                    <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                                        {this.state.erroresDetalle.length > 0 ? (
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th><FormattedMessage id="movilesRutasImportFilesGrid.column.row" defaultMessage="Fila" /></th>
                                                        <th><FormattedMessage id="movilesRutasImportFilesGrid.column.error" defaultMessage="Error" /></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.erroresDetalle.map((err, idx) => (
                                                        <tr key={idx}>
                                                            <td>{err.row_number}</td>
                                                            <td>{err.error_message}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div><FormattedMessage id="movilesRutasImportFilesGrid.noErrorsFound" defaultMessage="No se encontraron errores." /></div>
                                        )}
                                    </div>
                                    <div className="modal-footer modal-grey">
                                        <button type="button" className="btn btn-default btn-fleet" onClick={this.closeErroresModal}><FormattedMessage id="movilesRutasImportFilesGrid.close" defaultMessage="Cerrar" /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default injectIntl(MovilesRutasImportFilesGrid);
